import { GamManagerState } from '@pubstack/common/src/gam/gamManager'
import { FunctionComponent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGamIntegration } from '~/api/admin/gam-integration.api'
import { useGamManagerAdmConfigStatus, useGamManagerState, useRunGamManagerCreation } from '~/api/admin/gam-manager.api'
import { GamManagerStateToDisplay, PureGamManager } from './PureGamManager'

function toDisplay(state: GamManagerState): GamManagerStateToDisplay {
  return {
    creativeNames: state.creatives?.map((c) => c.name) ?? [],
    lineItemCount: state.lineItems?.length ?? 0,
    orderNames: state.orders?.map((o) => o.name) ?? [],
    associations: state.lineItemCreativeAssociations?.length ?? 0,
  }
}

export const GamManager: FunctionComponent = () => {
  const { scopeId } = useParams()

  const [selectedNetworkId, setSelectedNetworkId] = useState<string>()

  const { data: gamIntegration, isLoading: isIntegrationLoading } = useGamIntegration(scopeId)
  const { data: configStatus, isFetching: isConfigStatusLoading } = useGamManagerAdmConfigStatus(scopeId ?? '', selectedNetworkId)
  const { data: managerState } = useGamManagerState(scopeId ?? '', selectedNetworkId)
  const { mutateAsync: runCreation, isPending: isCreationPending } = useRunGamManagerCreation(scopeId ?? '', selectedNetworkId ?? '', {
    successToast: `Success for network ${selectedNetworkId}`,
    errorToast: `Failed for network ${selectedNetworkId}`,
  })

  const networks = gamIntegration?.gamNetworks ?? []
  const gamManagerStateToDisplay = managerState ? toDisplay(managerState) : undefined
  const isRunning = configStatus?.status === 'RUNNING'
  const isLoading = isIntegrationLoading || isConfigStatusLoading || isCreationPending

  return (
    <PureGamManager
      networks={networks}
      isRunning={isRunning}
      isLoading={isLoading}
      runCreationProcess={async () => await runCreation()}
      onNetworkChange={(option) => setSelectedNetworkId(option.id)}
      state={gamManagerStateToDisplay}
    />
  )
}
